import CategoryDTO from "./CategoryDTO.js"
import CompetitionDisciplineDTO from "./CompetitionDisciplineDTO.js"
import DisciplineDTO from "./DisciplineDTO.js"
import EpreuveDTO from "./EpreuveDTO.js"
import SportEventDTO from "./SportEventDTO.js"

class PhaseDTO {

    constructor(phaseData){
        if(!phaseData || Object.keys(phaseData).length === 0 )
            return

        const {_id, provider, name, epreuve, category, competitionDiscipline, sportEvents } = phaseData

        this._id = _id
        this.provider = provider

        this.name = name
        this.epreuve = epreuve ? new EpreuveDTO(epreuve) : undefined
        this.category = category ? new CategoryDTO(category) : undefined

        this.sportEvents = sportEvents?.map(sportEvent => new SportEventDTO(sportEvent))

        this.competitionDiscipline = competitionDiscipline ? new CompetitionDisciplineDTO(competitionDiscipline) : undefined
    }
}

export default PhaseDTO